export default "__VITE_PUBLIC_ASSET__29ecbf7c__"